import RibbonFormatState from '../store/schema/RibbonFormatState';
import { FormatState } from 'roosterjs-editor-types';
import { action } from 'satcheljs/lib/legacy';

export default action('updateCachedFormatViewState')(function updateCachedFormatViewState(
    ribbonFormatState: RibbonFormatState,
    formatState: FormatState
) {
    ribbonFormatState.formatPainterFormat = formatState;
});
